import {
  SegmentActionName,
  SegmentObjectName,
  trackLegacyEvent,
} from '@heidi/analytics/events';

export function trackUseHeidiButtonClicked() {
  trackLegacyEvent({
    name: SegmentObjectName.General,
    props: {
      action: SegmentActionName.UseHeidiClicked,
    },
  });
}
